import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type SectionWidth = "narrow" | "default" | "wide" | "full";

interface SectionProps {
  width?: SectionWidth;
  className?: string;
  id?: string;
  children: ReactNode;
}

const widthClasses: Record<SectionWidth, string> = {
  narrow: "max-w-[720px]",
  default: "max-w-[1000px]",
  wide: "max-w-[1200px]",
  full: "",
};

function Section({ width = "default", className, id, children }: SectionProps) {
  return (
    <section id={id} className={cn("py-16 md:py-20 px-5 mx-auto", widthClasses[width], className)}>
      {children}
    </section>
  );
}

export { Section, type SectionProps };
